import React, { useEffect } from "react"
import Loading from "../layouts/Loading"

const PUBLIC_SITE_URL = "https://oktto.com.br"

const PublicLegalRedirect = ({ path }) => {
    useEffect(() => {
        const destination = new URL(path, PUBLIC_SITE_URL)
        destination.search = window.location.search
        destination.hash = window.location.hash
        window.location.replace(destination.toString())
    }, [path])

    return <Loading fullPage={true} />
}

export default PublicLegalRedirect
